<template>
  <v-row>
    <v-col
      v-for="(spot, index) in spots_reversed"
      :key="index"
      cols="2"
      class="py-0"
    >
      <v-text-field
        :value="spot"
        @input="setSpot(index, $event)"
        :label="$t('pickup') + ' ' + (index + 1)"
        :rules="rules"
        :disabled="disabled"
        type="number"
        outlined
        rounded
        dense
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
// Els intervals es desen de més llunyà a més proper ([60, 30, 15, 7, 3, 1]) i es
// pinten a l'inrevés: "Pickup 1" és el més proper, l'última posició de l'array.
// És el mateix criteri que fa servir el backend amb el hash pickup_1..pickup_6.
export default {
  name: "a-hotel-configuration-pickup-intervals",
  props: {
    item: {
      type: Object,
      default: function() {
        return {};
      },
      required: true
    },
    // Clau de item.settings que s'edita. La pantalla d'hotel edita
    // hotel_pickup_spots, que el backend plega cap a pickup_spots en desar.
    settings_key: {
      type: String,
      default: "hotel_pickup_spots"
    },
    // Valor amb què s'inicialitza si la clau no existeix. Qui munta el component
    // ha de passar-hi el valor real que aplica (el del hotel, per exemple): un
    // default inventat aquí acabaria desat com si l'hagués escrit l'usuari.
    fallback: {
      type: Array,
      default: function() {
        return [60, 30, 15, 7, 3, 1];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    spots() {
      const value =
        this.item && this.item.settings
          ? this.item.settings[this.settings_key]
          : null;
      return Array.isArray(value) ? value : [];
    },
    spots_reversed() {
      return this.spots.slice().reverse();
    },
    rules() {
      return [v => (v && v > 0) || this.$t("validation_number_must_positive")];
    }
  },
  methods: {
    setSpot(index, value) {
      const next = this.spots.slice();
      const parsed = parseInt(value, 10);
      next[next.length - 1 - index] = Number.isFinite(parsed) ? parsed : value;
      this.$set(this.item.settings, this.settings_key, next);
    }
  },
  beforeMount() {
    if (!this.item.settings) {
      this.$set(this.item, "settings", {});
    }
    if (!Array.isArray(this.item.settings[this.settings_key])) {
      this.$set(this.item.settings, this.settings_key, this.fallback.slice());
    }
  }
};
</script>
